import { api } from "../api";

export interface CustomFieldOption {
  label: string;
  value: string;
}

export interface CustomFieldValidation {
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  min?: number;
  max?: number;
  customMessage?: string;
}

export type CustomFieldType =
  | "text"
  | "email"
  | "number"
  | "select"
  | "checkbox"
  | "radio"
  | "textarea"
  | "date"
  | "file";

export interface StaffCustomField {
  id: string;
  name: string;
  label: string;
  type: CustomFieldType;
  required: boolean;
  placeholder?: string;
  validation?: CustomFieldValidation;
  options?: CustomFieldOption[];
  order: number;
}

export interface StaffCustomFieldsConfig {
  customFields: StaffCustomField[];
}

export const staffCustomFieldsApi = {
  getConfig: async (tenantId: string): Promise<StaffCustomFieldsConfig> => {
    const response = await api.get(`/tenants/${tenantId}/staff-custom-fields`);
    return response.data;
  },

  updateConfig: async (
    tenantId: string,
    config: StaffCustomFieldsConfig
  ): Promise<StaffCustomFieldsConfig> => {
    const response = await api.put(`/tenants/${tenantId}/staff-custom-fields`, config);
    return response.data;
  },
};
